module.exports = __webpack_public_path__ + "img/Speed-Roulette-new.48c4e62.png";